import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitEvidenceSubmissionsMutationVariables = Types.Exact<{
  input: Types.SubmitEvidenceSubmissionsInput;
}>;


export type SubmitEvidenceSubmissionsMutation = { __typename?: 'mutation_root', submit_evidence_submissions?: { __typename?: 'SubmitEvidenceSubmissionsOutput', success: boolean, submission_ids: Array<any>, finding_id?: any | null, error?: string | null } | null };


export const SubmitEvidenceSubmissionsDocument = gql`
    mutation submitEvidenceSubmissions($input: SubmitEvidenceSubmissionsInput!) {
  submit_evidence_submissions(input: $input) {
    success
    submission_ids
    finding_id
    error
  }
}
    `;
export type SubmitEvidenceSubmissionsMutationFn = Apollo.MutationFunction<SubmitEvidenceSubmissionsMutation, SubmitEvidenceSubmissionsMutationVariables>;

/**
 * __useSubmitEvidenceSubmissionsMutation__
 *
 * To run a mutation, you first call `useSubmitEvidenceSubmissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitEvidenceSubmissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitEvidenceSubmissionsMutation, { data, loading, error }] = useSubmitEvidenceSubmissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitEvidenceSubmissionsMutation(baseOptions?: Apollo.MutationHookOptions<SubmitEvidenceSubmissionsMutation, SubmitEvidenceSubmissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitEvidenceSubmissionsMutation, SubmitEvidenceSubmissionsMutationVariables>(SubmitEvidenceSubmissionsDocument, options);
      }
export type SubmitEvidenceSubmissionsMutationHookResult = ReturnType<typeof useSubmitEvidenceSubmissionsMutation>;
export type SubmitEvidenceSubmissionsMutationResult = Apollo.MutationResult<SubmitEvidenceSubmissionsMutation>;
export type SubmitEvidenceSubmissionsMutationOptions = Apollo.BaseMutationOptions<SubmitEvidenceSubmissionsMutation, SubmitEvidenceSubmissionsMutationVariables>;